/* @flow */

import { SkippingKind } from '../../components/player/constantsAndTypes';
import { SKIP_DURATION, type SkipDuration } from './constants';
import { SkipDirection } from './types';

export enum ControlLevel {
  Level0,
  Level1,
  Level2,
}

const eventToControlLevel = (event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement> | SyntheticKeyboardEvent<HTMLElement>): ControlLevel => {
  const { ctrlKey, shiftKey } = event;

  if (shiftKey) {
    return ControlLevel.Level2;
  }

  if (ctrlKey) {
    return ControlLevel.Level1;
  }

  return ControlLevel.Level0;
};

const getSkippingTypeAndValue = (
  direction: SkipDirection,
  event?: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement> | SyntheticKeyboardEvent<HTMLElement>,
): { type: SkippingKind, value: SkipDuration } => {
  let type: SkippingKind = direction === SkipDirection.Forward ? SkippingKind.ForwardLevel0 : SkippingKind.BackwardLevel0;
  let value: SkipDuration = SKIP_DURATION.Level0;

  if (event) {
    const controlLevel = eventToControlLevel(event);

    switch (controlLevel) {
      case ControlLevel.Level1:
        type = direction === SkipDirection.Forward ? SkippingKind.ForwardLevel1 : SkippingKind.BackwardLevel1;
        value = SKIP_DURATION.Level1;
        break;

      case ControlLevel.Level2:
        type = direction === SkipDirection.Forward ? SkippingKind.ForwardLevel2 : SkippingKind.BackwardLevel2;
        value = SKIP_DURATION.Level2;
        break;

      default:
      // Nothing to do
    }
  }

  if (direction === SkipDirection.Backward) {
    value = -value;
  }

  return {
    type,
    value,
  };
};

export { getSkippingTypeAndValue, eventToControlLevel };
